import { createReducer } from '../utils/createReducer';
import { request } from "../utils/request";
import { Toast } from "antd-mobile";

const namespace: string = "file";

const initialState = {
  files: [],
  hasFile: false,
};

const reducer = {
  onGetFileListSuccess(state: any, action: any) {
    if (action.error || action.result.error) {
      return { ...state, files: [], hasFile: false }
    }
    return { ...state, files: action.result, hasFile: true };
  },

  onGetFileListFailed(state: any, action: any) {
    // Toast.fail("获取附件失败", 2);
    return { state, hasFile: false, };
  }
};

export default createReducer(initialState, reducer, namespace)

export function getFileList(action: any): Actions {
  return {
    types: ["file/onGetFileList", "file/onGetFileListSuccess", "file/onGetFileListFailed"],
    promise: request(`/get_attach_file`, {
      method: "GET", body: {
        id: action.articleId
      }
    }),
    action
  }
}




// WEBPACK FOOTER //
// ./src/reducers/file.ts